import { Badge, Card, CardContent, CardHeader, CardTitle } from '@chain-zen/ui'
import React from 'react'

import type { IPrivatePostWithOffers } from '../../../types/post'
import { currencyFormatter } from '../../../utils/common'
import { LabelRow } from '../../shared/label-row'

const OfferRate = ({ value }: { value?: string }) => {
  if (!value) {
    return <span className="text-gray-600">--</span>
  }

  return (
    <Badge variant="secondary" className="w-fit font-normal">
      ${currencyFormatter(value.toString(), 2)}
    </Badge>
  )
}

const ensurePercentageSymbol = (value: string) => {
  if (!value.includes('%')) {
    return value + '%'
  }
  return value
}

/**
 * Displays the details of a post offer rates
 */
export const PostRates = ({ post }: { post: IPrivatePostWithOffers }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Post rates</CardTitle>
      </CardHeader>
      <CardContent>
        <LabelRow label="Max Rate">
          <OfferRate value={post?.tmsRates?.maxRate?.value} />
        </LabelRow>

        <LabelRow label="Start Rate">
          <OfferRate value={post?.tmsRates?.startRate?.value} />
        </LabelRow>

        <LabelRow label="Target Rate">
          <OfferRate value={post?.tmsRates?.targetRate?.value} />
        </LabelRow>

        {!!post?.greenscreensRates?.confidenceLevel && (
          <LabelRow label="GS Confidence Level">
            <span className="text-gray-900 dark:text-gray-100">
              {ensurePercentageSymbol(post.greenscreensRates.confidenceLevel)}
            </span>
          </LabelRow>
        )}

        {!!post?.greenscreensRates?.minRate && (
          <LabelRow label="GS Low Buy Rate">
            <OfferRate value={post.greenscreensRates.minRate.value} />
          </LabelRow>
        )}

        {!!post?.greenscreensRates?.maxRate?.value && (
          <LabelRow label="GS Max Buy Rate">
            <OfferRate value={post.greenscreensRates.maxRate.value} />
          </LabelRow>
        )}

        {!!post?.greenscreensRates?.targetRate?.value && (
          <LabelRow label="GS Target Buy Rate">
            <OfferRate value={post.greenscreensRates.targetRate.value} />
          </LabelRow>
        )}
      </CardContent>
    </Card>
  )
}
